import React, { Component } from 'react';
import { connect } from 'react-redux';
import { sendMessage, watchMessages } from 'thunks/timesheets';
import { clearMessages } from 'reducers/timesheets';
import Loading from 'components/Loading';
import { MdClose } from 'react-icons/md';
import Button from 'components/Button';
import MessageBar from './MessageBar';
import TimesheetAuditTrailItem from './TimesheetAuditTrailItem';

import './style.scss';

export class TimesheetMessagesView extends Component {

  static propTypes = {
  }

  static defaultProps = {
  }

  state = { }

  componentDidMount() {
    this.watchMessages();
    this.scrollToBottom();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.timesheetKey !== this.props.timesheetKey) this.watchMessages();
    if (prevProps.messages !== this.props.messages) {
      this.scrollToBottom();
    }
  }

  componentWillUnmount() {
    this.subscription?.unsubscribe();
    this.props.clearMessages();
  }

  watchMessages = () => {
    this.subscription?.unsubscribe();
    this.subscription = this.props.watchMessages(this.props.timesheetKey);
  }

  scrollToBottom = () => {
    if (!this.messageList) return;
    const scrollHeight = this.messageList.scrollHeight;
    const height = this.messageList.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.messageList.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }

  render() {
    const adminIsInSameOrgAsShift = this.props.adminOrgKey === this.props.shiftOrgKey;

    return (
      <div
        className="timesheet-messages"
      >
        <div className="timesheet-messages__heading">
          <h4 className="timesheet__header timesheet-messages__header">Messages &amp; Audit Trail</h4>
          {this.props.onRequestClose && (
            <button type="button" className="timesheet-details__close" aria-label="Close timesheet" onClick={this.props.onRequestClose}><MdClose size={24} /></button>
          )}
        </div>
        {this.props.timesheetMessagesError && (
          <div role="alert" style={{ padding: 16 }}>
            <p>{this.props.timesheetMessagesError}</p>
            <Button small onClick={this.watchMessages}>Retry</Button>
          </div>
        )}
        {this.props.fetchingTimesheetMessages ?
          <div style={{ display: 'flex', height: '100%', width: '100%', justifyContent: 'center', alignItems: 'center' }}><Loading /></div>
          :
          <>
            <div
              ref={(div) => {
                this.messageList = div;
              }}
              className="timesheet-messages__scrollview"
            >
              {!this.props.messages.length && !this.props.timesheetMessagesError && <p style={{ padding: 16 }}>No messages or audit entries yet.</p>}
              {this.props.messages.map((message, index) => {
                return (<TimesheetAuditTrailItem
                  message={message}
                  key={message.key || `${message.sent_at}-${index}`}
                />);
              })}
            </div>
            {adminIsInSameOrgAsShift && (
              <MessageBar isSendingMessage={this.props.sendingMessage} sendMessage={message => this.props.sendMessage(this.props.timesheetKey, message)} focusTextArea={() => this.scrollToBottom()} />
            )}
          </>
        }
      </div>
    );
  }
}

function mapStateToProps({ timesheets, jobs, global }, ownProps) {
  const shift = jobs?.details[ownProps.shiftKey]?.details;
  const shiftOrgKey = shift?.orgKey ?? null;
  return {
    adminOrgKey: global.currentOrgKey,
    shiftOrgKey,
    messages: timesheets.messages,
    sendingMessage: timesheets.sendingMessage,
    fetchingTimesheetMessages: timesheets.fetchingTimesheetMessages,
    timesheetMessagesError: timesheets.timesheetMessagesError,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    watchMessages: timesheetKey => dispatch(watchMessages(timesheetKey)),
    sendMessage: (timesheetKey, message) => dispatch(sendMessage(timesheetKey, message)),
    clearMessages: () => dispatch(clearMessages()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetMessagesView);
